import axios from 'axios'

const api  = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://Tripendarbackend-env.eba-ip7qrgmm.us-east-1.elasticbeanstalk.com/api', //'https://tripendardemo.herokuapp.com/api', //
  headers: {
    'Content-Type': 'application/json'
  }
})

export default api